/* ZINKE — Größen von klein nach groß (25.09.2026, Theme 7.8)
   =========================================================
   Pascal: „die Größenauswahl von links nach rechts von klein nach groß".

   Shopify liefert Optionswerte in der Reihenfolge, die im Produkt hinterlegt
   ist. Beim Import stand dort die alphabetische: 2XL, L, M, S, XL. Sieben
   Produkte wurden am 25.09. per productOptionsReorder in den Daten korrigiert.
   Bei EINEM Wert — XS beim Hemd in fünfzehn Farben — nahm Shopify die neue
   Reihenfolge an (keine userErrors), setzte sie aber nicht um; XS bleibt an
   achter Stelle.

   Diese Datei ist das Netz darunter: Sie sortiert die Knöpfe im Frontend,
   unabhängig davon, was in den Daten steht. Damit stimmt die Reihenfolge auch
   bei jedem Produkt, das künftig importiert wird, ohne dass jemand daran denken
   muss.

   Sortiert wird nur, wenn JEDER Wert der Option erkannt wird — sonst bleibt
   alles, wie es ist. Eine Option „Farbe" oder „Zusammenstellung A bis J" wird
   also nie angefasst. */

(() => {
  'use strict';

  var RANG = {
    'XXXS': 5, '3XS': 5,
    'XXS': 10, '2XS': 10,
    'XS': 20,
    'S': 30,
    'M': 40,
    'L': 50,
    'XL': 60,
    'XXL': 70, '2XL': 70,
    'XXXL': 80, '3XL': 80,
    'XXXXL': 90, '4XL': 90,
    'XXXXXL': 100, '5XL': 100,
    '6XL': 110, '7XL': 120, '8XL': 130
  };

  /* Zahl -> nach Zahl sortieren (Schuhgröße, Kragenweite).
     Buchstabengröße -> nach Tabelle. Sonst null = Finger weg. */
  function rang(text) {
    var t = String(text || '').trim().toUpperCase().replace(/\s+/g, '');
    if (t === '') return null;
    if (/^\d+([.,]\d+)?$/.test(t)) return 1000 + parseFloat(t.replace(',', '.'));
    if (Object.prototype.hasOwnProperty.call(RANG, t)) return RANG[t];
    return null;
  }

  function sortieren(gruppe) {
    var knoepfe = Array.prototype.slice.call(gruppe.querySelectorAll('.z-opt-w'));
    if (knoepfe.length < 3) return;

    var paare = [];
    for (var i = 0; i < knoepfe.length; i++) {
      var name = knoepfe[i].getAttribute('data-z-name') || knoepfe[i].textContent;
      var r = rang(name);
      if (r === null) return;              // ein unbekannter Wert: gar nicht sortieren
      paare.push({ knopf: knoepfe[i], rang: r, stelle: i });
    }

    var schon = true;
    for (var k = 1; k < paare.length; k++) {
      if (paare[k].rang < paare[k - 1].rang) { schon = false; break; }
    }
    if (schon) return;                     // steht bereits richtig

    paare.sort(function (a, b) {
      return a.rang === b.rang ? a.stelle - b.stelle : a.rang - b.rang;
    });
    paare.forEach(function (p) { gruppe.appendChild(p.knopf); });
  }

  function starten(bereich) {
    var wurzel = bereich && bereich.querySelectorAll ? bereich : document;
    Array.prototype.slice.call(wurzel.querySelectorAll('.z-opt-werte.z-opt-knoepfe')).forEach(sortieren);
  }

  /* Die Kaufspalte wird bei jedem Variantenwechsel von zinke.js neu
     geschrieben — danach steht die alte Reihenfolge wieder da. */
  document.addEventListener('zinke:variant:change', function () { setTimeout(starten, 0); });
  document.addEventListener('shopify:section:load', function (e) { starten(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { starten(); });
  } else {
    starten();
  }
})();
